/**
 * Checks whether given value is empty
 */
export function isEmpty<T = unknown>(value: T, ignoreWhitespace = true): boolean {
    if (value == null) {
        return true;
    }

    switch (typeof value) {
        case "string":
            return ignoreWhitespace ? value.length === 0 : value.trim().length === 0;
        case "number":
        case "boolean":
            return !value;
        case "undefined":
            return true;
        case "object":
            return Object.keys(value).length === 0;
        case "function":
        case "symbol":
            return false;
        default:
            return !value;
    }
}

export function isNonEmptyString(str: unknown): str is string {
    return typeof str === "string" && !isEmpty(str, false);
}
